var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloud = function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 93 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Cloud_svg__a)",
    stroke: "currentColor",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.097 39.528H41.07L28.498 52.1v13.718l6.166 6.88 14.433.001h23.449l6.548-5.6v-8.451L72.546 52.1H61.669L49.097 39.528Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.304 41.897v-6.548L52.732 22.776h-8.027L32.133 35.35H21.256l-6.548 6.548v8.45l6.548 5.6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Cloud_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.901)",
    d: "M0 0h92v92H0z"
  })))));
};
export default SvgCloud;